import React, { Component } from 'react';
import axios from 'axios';

import loadingSpinner from '../img/loading-spinner.svg';
import '../scss/RelatedResearchContainer.scss';
import RelatedResearch from "./RelatedResearch";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


class RelatedResearchContainer extends Component {
    constructor (props) {
        super(props);

        this.state = {
            relatedDocs: [],
            isLoading: true,
            display: true,
            displayButton: true,
            showOrHideText: 'Hide'
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps) {
            this.setState(prevState => ({
                displayButton: !this.isMobileDevice() ? true : (newProps.display || prevState.display)
            }));
        }
    }

    componentDidMount () {
        window.addEventListener("resize", this.updateContainerSize);
        window.addEventListener("zoom", this.updateContainerSize);

        let self = this;
        let aid = this.props.clientActionId;
        let timestamp = this.props.startTimestamp;
        let signature = this.props.permsSignature;
        let baseUrl = decodeURIComponent(this.props.referrer.replace(/\+/g, ' '))
        let relatedResearchUrl = baseUrl + 'SingletrackCMS__RelatedResearch'
        let dataService = process.env.REACT_APP_ENGAGEMENT_SERVICE_URI + '/' + process.env.REACT_APP_ENGAGEMENT_DATA

        axios.get(`${dataService}?url=${relatedResearchUrl}&aid=${aid}&timestamp=${timestamp}&sign=${signature}`)
            .then( resp => {
                if (!resp.data.error && resp.data.documents && resp.data.parentClientActionId === aid && resp.data.documents.length > 0) {
                    this.setState( prevState => ({
                        isLoading: false,
                        relatedDocs: resp.data.documents.sort(self.sortDocumentsByPriority())
                    }));
                } else {
                    this.setState( prevState => ({
                        isLoading: false,
                        relatedDocs: []
                    }));

                    this.hideContainer();
                }
            })
            .catch( err => {
                console.log('Error fetching and parsing related research data', err);
                this.setState( prevState => ({
                    isLoading: false,
                    relatedDocs: []
                }));

                this.hideContainer();
            });
    }

    sortDocumentsByPriority = () => {
        const field = 'isPriority';

        return function (a,b) {
            return (a[field] === false && b[field] === true) ? 1 : (a[field] === true && b[field] === false) ? -1 : 0;
        }
    }

    isMobileDevice() {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
    }

    updateContainerSize = (e) => {
        const docWidth = this.props.getDocPageWidth();
        const availableWidth = - 38 - 27 - 16 + (window.outerWidth - docWidth) / 2;
        let container = document.getElementsByClassName('container-section-main')[0];
        
        if (!container || docWidth <= 0) return;

        if (availableWidth >= 240) {
            container.setAttribute("style", "width:" + availableWidth + "px");
            if (!this.state.display) {
                this.handleExpandContainerClick();
            }
        } else if (this.state.display) {
            this.handleExpandContainerClick();
        }
    }

    hideContainer = () => {
        if (this.state.relatedDocs.length !== 0) return;

        let self = this;
        setTimeout( function() {
            if (self.state.display === true) {
                document.getElementById("btnExpandResearchContainer").click();
            }
        }, 2000)
    }

    handleSummaryArrowClick = (iconsId, summaryId) => {
        let divSummary = document.getElementById(summaryId);
        let divArrows = document.getElementById(iconsId);
        if (!divSummary || !divArrows) return;

        let preview = divSummary.firstElementChild;
        let remaining = divSummary.lastElementChild;
        let arrowDown = divArrows.firstElementChild;
        let arrowUp = divArrows.lastElementChild;

        let arrowDownClasses = arrowDown.getAttribute('class');
        let arrowUpClasses = arrowUp.getAttribute('class');

        if (preview.textContent.endsWith('...')) {
            preview.textContent = preview.textContent.trim().substring(0, preview.textContent.length - 3);
            remaining.classList.remove("hidden");
            arrowDown.setAttribute('class', arrowDownClasses + ' hidden');
            arrowUp.setAttribute('class', arrowUpClasses.replace('hidden', ''));
        } else if (remaining.textContent.length > 0) {
            preview.textContent += '...';
            remaining.classList.add("hidden");
            arrowDown.setAttribute('class', arrowDownClasses.replace('hidden', ''));
            arrowUp.setAttribute('class', arrowUpClasses + ' hidden');
        }
    }

    handleExpandContainerClick = (e) => {
        const btn = document.getElementById("btnExpandResearchContainer");
        if (!btn) return;

        let showOrHide = '';
        let arrowDown = btn.firstElementChild;
        let arrowUp = btn.lastElementChild;

        let arrowDownClasses = arrowDown.getAttribute('class');
        let arrowUpClasses = arrowUp.getAttribute('class');

        if (arrowDownClasses.includes("hidden")) {
            showOrHide = "Hide";
            arrowDown.setAttribute('class', arrowDownClasses.replace('hidden', ''));
            arrowUp.setAttribute('class', arrowUpClasses + ' hidden');
        } else {
            showOrHide = "Show";
            arrowDown.setAttribute('class', arrowDownClasses + ' hidden');
            arrowUp.setAttribute('class', arrowUpClasses.replace('hidden', ''));
        }

        this.setState( prevState => ({
            display: !prevState.display,
            displayButton: !this.isMobileDevice() ? true : (this.props.display || !prevState.display),
            showOrHideText: showOrHide
        }));
    }

    renderResearchResults = () => {
        if (this.state.isLoading) {
            return (
                <img src={loadingSpinner} alt="Loading" className="loading" />
            );
        } else {
            return (
                (this.state.relatedDocs.length === 0)
                    ?   <p className="centered-text"> No related documents found. </p>
                    :   <RelatedResearch relatedDocs={ this.state.relatedDocs } handleSummaryArrowClick={ this.handleSummaryArrowClick }
                                         handleRelatedResearchClick={ this.props.handleRelatedResearchClick } />
            );
        }
    }

    render () {
        return (
            <div className="RelatedResearchContainer">
                <div className="container-section-button" data-display={ this.state.displayButton }>
                    <button id="btnExpandResearchContainer" onClick={ this.handleExpandContainerClick }>
                        {this.state.showOrHideText} Missed Research &nbsp;
                        <FontAwesomeIcon icon="angle-double-down" size="sm" />
                        <span className="counter-badge" data-docs-count={ this.state.relatedDocs.length }></span>
                        <FontAwesomeIcon icon="angle-double-up" size="sm" className="hidden" />
                    </button>
                </div>
                <div className="container-section-main" data-display={ this.state.display }>
                    <span className="container-section-heading"> RESEARCH YOU MAY HAVE MISSED </span>
                    <hr/>
                    <div className="container-section-docs">
                        { this.renderResearchResults() }
                    </div>
                </div>
            </div>
        );
    }
}

export default RelatedResearchContainer;
